{
  "auth.login.email.error_format": "Veuillez saisir une adresse email valide",
  "auth.login.email.label": "Adresse email",
  "auth.login.email.placeholder": "Adresse email",
  "auth.login.forgot_password": "Mot de passe oublié ?",
  "auth.login.log_in": "Connexion",
  "auth.login.password.label": "Mot de passe",
  "auth.login.password.placeholder": "Mot de passe",
  "auth.login.password.required": "Mot de passe requis"
}
